module.exports = __webpack_public_path__ + "../../../static/img/c_im_13.31383df4.png";